import { createReducer, on } from '@ngrx/store';
import { VehicleActions } from './vehicle.actions';
import { Pagination } from '@core/interface/core';
import { Vehicle } from '@core/interface/fleet/vehicle';

export const vehicleFeatureKey = 'vehicle';

export interface VehicleState {
  vehicles: {
    data: Vehicle[];
    isLoading: boolean;
    pagination: Pagination | null;
    isDeleted: boolean;
  };
  isExcelLoading?: boolean;
}

export const initialState: VehicleState = {
  vehicles: {
    data: [],
    isLoading: false,
    isDeleted: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 100,
    },
  },
  isExcelLoading: false,
};

export const VehicleReducer = createReducer(
  initialState,
  on(VehicleActions.loadVehicles, (state) => ({
    ...state,
    vehicles: { ...state.vehicles, isLoading: true, data: [] },
  })),
  on(VehicleActions.loadVehiclesSuccess, (state, { data, pagination }) => ({
    ...state,
    vehicles: { ...state.vehicles, data, pagination, isLoading: false },
  })),
  on(VehicleActions.loadVehiclesFailure, (state) => ({
    ...state,
    vehicles: { ...state.vehicles, data: [], isLoading: false },
  })),
  on(VehicleActions.resetVehicles, (state) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      data: [],
      isLoading: false,
      pagination: null,
    },
  })),
  on(VehicleActions.addVehicleSuccess, (state, { data }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      data: [...state.vehicles.data, data],
      isLoading: false,
    },
  })),
  on(VehicleActions.updateVehicleSuccess, (state, { data }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      data: state.vehicles.data.map((vehicle) =>
        data.id == vehicle.id ? data : vehicle
      ),
      isLoading: false,
    },
  })),
  on(VehicleActions.exportExcelVehicles, (state) => ({
    ...state,
    isExcelLoading: true,
  })),
  on(VehicleActions.exportExcelVehiclesSuccess, (state) => ({
    ...state,
    isExcelLoading: false,
  })),
  on(VehicleActions.exportExcelVehiclesFailure, (state) => ({
    ...state,
    isExcelLoading: false,
  })),

  on(VehicleActions.deleteVehicleSuccess, (state, { success, id }) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      isDeleted: success,
      data: state.vehicles.data.filter((vehicle) => vehicle.id !== id),
      isLoading: false,
    },
  })),
  on(VehicleActions.deleteVehicleFailure, (state, error) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      isDeleted: false,
    },
    deleteError: error,
  })),
  on(VehicleActions.resetDeleteStatus, (state) => ({
    ...state,
    vehicles: {
      ...state.vehicles,
      isDeleted: false,
    },
  }))
);
